import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const Gray = styled.div`
    position: absolute;
    height: 100%;
    width: ${props => props.percent}%;
    background-color: #e4e4e4;
    top: 0;
    right: 0;
    transition: width 2s;
`;
const BarGradient = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: rgb(124, 124, 173);
    background: linear-gradient(90deg, rgb(36, 110, 255, 1) 0%, rgb(54, 37, 168, 1) 100%);
`;

const ProgressBar = ({ percent = 0 }) => (
    <div style={{ width: '100%', position: 'relative', height: '15px' }}>
        <BarGradient />
        <Gray percent={100 - percent} />
    </div>
);

ProgressBar.propTypes = {
    percent: PropTypes.number,
};

export default ProgressBar;
